<!--
 * Path: packages/frontend/src/features/browser/forms/number/NumberEdit.vue
 * Task: Input component for numbers ensuring strict type coercion for calculations.
-->
<template>
  <v-text-field
    v-model.number="modelValue"
    type="number"
    :step="stepValue"
    variant="outlined"
    density="compact"
    hide-details="auto"
    :error-messages="errorMessages"
    autofocus
    @keydown.enter="$emit('save')"
    class="mb-0"
  >
    <template v-if="type === 'currency'" v-slot:prepend-inner>
      <v-icon size="small" color="medium-emphasis" class="me-1">mdi-currency-eur</v-icon>
    </template>
  </v-text-field>
</template>

<script setup lang="ts">
import { computed } from 'vue';

const props = defineProps<{
  type: string;
  errorMessages?: string | string[];
}>();

defineEmits<{ (e: 'save'): void }>();

const modelValue = defineModel<number | string | null>();

const stepValue = computed(() => {
  return props.type === 'integer' ? '1' : 'any';
});
</script>
